import React, { useEffect, useState } from 'react'

import './style.scss';
import { setButtonClick, setErrorButton, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import CustomTitle from '../../components/UI/title/CustomTitle';
import ReachContent from './ReachContent';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';

export default function Reach({productivity}) {
    const initialCheckboxState = [
        [
            {
                id: '0',
                checked: false,
                title: 'Next month',
                number: '1',
                text: "months",
                days: '30',
            },
            {
                id: '1',
                checked: false,
                title: 'In three months',
                number: '3',
                text: "months",
                days: '90',
            },
            {
                id: '2',
                checked: false,
                title: 'In six months',
                number: '6',
                text: "months",
                days: '180',
            },
            {
                id: '3',
                checked: false,
                title: 'In nine months',
                number: '9',
                text: "months",
                days: '270',
            }
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'In two weeks',
                number: '2',
                text: "weeks",
                days: '14',
            },
            {
                id: '1',
                checked: false,
                title: 'In four weeks',
                number: '4',
                text: "weeks",
                days: '28',
            },
            {
                id: '2',
                checked: false,
                title: 'In six weeks',
                number: '6',
                text: "weeks",
                days: '42',
            },
            {
                id: '3',
                checked: false,
                title: 'In eight weeks',
                number: '8',
                text: "weeks",
                days: '56',
            }
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'Next month',
                number: '1',
                text: "months",
                days: '30',
            },
            {
                id: '1',
                checked: false,
                title: 'In two months',
                number: '2',
                text: "months",
                days: '60',
            },
            {
                id: '2',
                checked: false,
                title: 'In three months',
                number: '3',
                text: "months",
                days: '90',
            },
            {
                id: '3',
                checked: false,
                title: 'In six months',
                number: '6',
                text: "months",
                days: '180',
            }
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'In a week',
                number: '1',
                text: "week",
                days: '7',
            },
            {
                id: '1',
                checked: false,
                title: 'In two weeks',
                number: '2',
                text: "weeks",
                days: '14',
            },
            {
                id: '2',
                checked: false,
                title: 'In four weeks',
                number: '4',
                text: "weeks",
                days: '28',
            },
            {
                id: '3',
                checked: false,
                title: 'In eight weeks',
                number: '8',
                text: "weeks",
                days: '56',
            }
        ]
    ];
    const initialCheckboxStateProductivity = [
        [
            {
                id: '0',
                checked: false,
                title: 'In a month',
                number: '1',
                text: "month",
                days: '30',
            },
            {
                id: '1',
                checked: false,
                title: 'In two months',
                number: '2',
                text: "months",
                days: '60',
            },
            {
                id: '2',
                checked: false,
                title: 'In three months',
                number: '3',
                text: "months",
                days: '90',
            },
            {
                id: '3',
                checked: false,
                title: 'In four months',
                number: '4',
                text: "months",
                days: '120',
            }
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'In a week',
                number: '1',
                text: "week",
                days: '7',
            },
            {
                id: '1',
                checked: false,
                title: 'In two weeks',
                number: '2',
                text: "weeks",
                days: '14',
            },
            {
                id: '2',
                checked: false,
                title: 'In four weeks',
                number: '4',
                text: "weeks",
                days: '28',
            },
            {
                id: '3',
                checked: false,
                title: 'In eight weeks',
                number: '8',
                text: "weeks",
                days: '56',
            }
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'In a week',
                number: '1',
                text: "week",
                days: '7',
            },
            {
                id: '1',
                checked: false,
                title: 'In two weeks',
                number: '2',
                text: "weeks",
                days: '14',
            },
            {
                id: '2',
                checked: false,
                title: 'In four weeks',
                number: '4',
                text: "weeks",
                days: '28',
            },
            {
                id: '3',
                checked: false,
                title: 'In eight weeks',
                number: '8',
                text: "weeks",
                days: '56',
            }
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'In a week',
                number: '1',
                text: "week",
                days: '7',
            },
            {
                id: '1',
                checked: false,
                title: 'In two weeks',
                number: '2',
                text: "weeks",
                days: '14',
            },
            {
                id: '2',
                checked: false,
                title: 'In four weeks',
                number: '4',
                text: "weeks",
                days: '28',
            },
            {
                id: '3',
                checked: false,
                title: 'In eight weeks',
                number: '8',
                text: "weeks",
                days: '56',
            },
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'In a week',
                number: '1',
                text: "week",
                days: '7',
            },
            {
                id: '1',
                checked: false,
                title: 'In two weeks',
                number: '2',
                text: "weeks",
                days: '14',
            },
            {
                id: '2',
                checked: false,
                title: 'In four weeks',
                number: '4',
                text: "weeks",
                days: '28',
            },
            {
                id: '3',
                checked: false,
                title: 'In eight weeks',
                number: '8',
                text: "weeks",
                days: '56',
            }
        ],
        [
            {
                id: '0',
                checked: false,
                title: 'In a week',
                number: '1',
                text: "week",
                days: '7',
            },
            {
                id: '1',
                checked: false,
                title: 'In two weeks',
                number: '2',
                text: "weeks",
                days: '14',
            },
            {
                id: '2',
                checked: false,
                title: 'In four weeks',
                number: '4',
                text: "weeks",
                days: '28',
            },
            {
                id: '3',
                checked: false,
                title: 'In eight weeks',
                number: '8',
                text: "weeks",
                days: '56',
            }
        ]
    ];


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [disabled, setDisabled] = useState(true);
  const [checkboxes, setCheckboxes] = useState(productivity? initialCheckboxStateProductivity[queryParams.get('productivity-goals-id') ?? 0] : initialCheckboxState[queryParams.get('goals') ?? 0]);
    const [error, setError] = useState(false);
    const [days, setDays] = useState(0);
    const [value, setValue] = useState();

    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            if (disabled) {
                setError(true);
                dispatch(setErrorButton(true))
                dispatch(setButtonClick(false));
                setTimeout(() => {
                    setError(false);
                    dispatch(setErrorButton(false))
                }, 2000);
                return;
            }
            dispatch(setButtonClick(false));
            queryParams.set('days', days);
            queryParams.set('period', value);
            trackP1Event('onboarding_ad_timeline', {
                timeline_productivity: value,
                goals: queryParams.get('goals-text')
            })
            history.push({
                pathname: 'reviews',
                search: `?${queryParams.toString()}`,
            });
        }
    }, [buttonClicked, dispatch, disabled, checkboxes]);


    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));
    }, []);



    return (
        <div className="reach page">
            <PageContent>
            <div className="page-content">
                <CustomTitle
                    style={{ marginBottom: '24rem' }}
                    title={'When do you want to reach your goal?'}
                />
                <div className="reach-wrapper">
                    <ReachContent setDays={setDays} setValue={setValue} setError={setError} checkboxes={checkboxes} setCheckboxes={setCheckboxes} error={error} setDisabled={setDisabled} />
                </div>

            </div>
            </PageContent>


        </div>
    )
}
